import Axios from "@/plugins/Axios";

export class InepService {
  async importar(form) {
    const response = await Axios().post("/inep", form);
    return response;
  }
}
export default new InepService();
